export default __webpack_public_path__ + "cross.36dad211.svg";